import { getUser } from '@src/services/auth';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'theme-ui';
import { checkIfLessonsWithinRange } from '../../calendar/components/selectedDates';
import BookALessonContent from './bookALessonContent';
import BookALessonFooter from './bookALessonFooter';
import BookALessonHeader from './bookALessonHeader';

const bookALesson = ({
  onNext,
  vm,
  onSelect,
  addToCart,
  isDisabled,
  setShowCalendar,
  lessonCount,
  setLessonCount,
  setShowSelectedDates,
  selectedTimes,
  selectedDiscount,
  setSelectedDiscount,
  priceWithDiscount,
  setPriceWithDiscount,
  discountOptions,
  cartModalPresenter,
}) => {
  const { t } = useTranslation();
  const user = getUser();
  const [lessonTopic, setLessonTopic] = useState(null);
  const [lessonType, setLessonType] = useState(
    vm.lessonTypes && vm.lessonTypes[0].value
  );
  const [lessonTypes, setLessonTypes] = useState([]);
  const [lessonGrades, setLessonGrades] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState();
  const [selectedGrade, setSelectedGrade] = useState('');
  const [lessonFor, setLessonFor] = useState(null);
  const [isSubjectInvalid, setIsSubjectInvalid] = useState(false);
  const [isGradeInvalid, setIsGradeInvalid] = useState(false);
  const [isTopicInvalid, setIsTopicInvalid] = useState(false);

  const [isLoadingPay, setIsLoadingPay] = useState(false);
  const [isLoadingCart, setIsLoadingCart] = useState(false);
  const [showDateError, setShowDateError] = useState(false);
  const [timeAlreadyInCart, setTimeAlreadyInCart] = useState(false);
  const [teacherSubjects, setTeacherSubjects] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (vm?.lessonTypes && vm?.lessonTypes?.length > 0) {
      const individualLessonType = vm.lessonTypes.find(
        (type) => type.lessonType === 1
      );
      setLessonType(individualLessonType.value);
    }
  }, [vm]);

  useEffect(() => {
    if (vm.hasLessonTypes) {
      const isEqual =
        JSON.stringify(vm.lessonTypes) === JSON.stringify(lessonTypes);
      if (!isEqual) {
        setLessonTypes(vm.lessonTypes);
      }
    }
  }, [vm.hasLessonTypes]);

  useEffect(() => {
    if (vm.teacherSubjects?.length > 0) {
      const isEqual =
        JSON.stringify(teacherSubjects) === JSON.stringify(vm.teacherSubjects);
      if (!isEqual) {
        setTeacherSubjects(vm.teacherSubjects);
      }
    }
  }, [vm.teacherSubjects]);

  useEffect(() => {
    setLessonTopic(null);
    setSelectedGrade('');
    document.getElementById('lessonTopic').value = '';
  }, [lessonFor]);

  useEffect(() => {
    if (lessonTypes?.length > 0) {
      const individualLessonType = lessonTypes.find(
        (type) => type.lessonType === 1
      );
      setLessonType(individualLessonType.value);
    }
  }, [lessonTypes]);

  useEffect(() => {
    if (teacherSubjects?.length > 0) {
      const subject = teacherSubjects[0];
      teacherSubjects.length === 1
        ? setSelectedSubject(subject.value)
        : setSelectedSubject('');
      teacherSubjects.length === 1
        ? setLessonGrades(subject?.grades || [])
        : setLessonGrades([]);
    }
  }, [teacherSubjects]);

  useEffect(() => {
    if (isSubjectInvalid && !!selectedSubject) {
      setIsSubjectInvalid(false);
    }
  }, [selectedSubject]);

  useEffect(() => {
    if (isTopicInvalid && !!lessonTopic) {
      setIsTopicInvalid(false);
    }
    if (isGradeInvalid && !!selectedGrade) {
      setIsGradeInvalid(false);
    }
    if (lessonTopic && selectedGrade) {
      setShowCalendar(true);
    } else {
      setShowCalendar(false);
    }
  }, [lessonTopic, selectedGrade]);

  useEffect(() => {
    let discount = 0;

    if (
      lessonCount >= discountOptions[1].count &&
      lessonCount < discountOptions[2].count
    ) {
      discount = discountOptions[1].discount;
    }
    if (
      lessonCount >= discountOptions[2].count &&
      lessonCount < discountOptions[3].count
    ) {
      discount = discountOptions[2].discount;
    }
    if (lessonCount >= discountOptions[3].count) {
      discount = discountOptions[3].discount;
    }
    if (discount !== selectedDiscount) {
      setSelectedDiscount(discount);
    }
  }, [lessonCount]);

  useEffect(() => {
    if (selectedDiscount) {
      let priceToSet = vm.price - (vm.price * selectedDiscount) / 100;
      setPriceWithDiscount(
        !(priceToSet % 1) ? priceToSet : priceToSet.toFixed(2)
      );
    }
  }, [selectedDiscount]);

  useEffect(() => {
    if (
      lessonCount === selectedTimes.length ||
      checkIfLessonsWithinRange(lessonCount, selectedTimes)
    ) {
      setErrorMessage('');
    }
    setTimeAlreadyInCart(false);
  }, [lessonCount, selectedTimes]);

  const handleCartAction = async (
    action,
    setLoading,
    setTimeAlreadyInCart,
    isNavigatingToCheckout
  ) => {
    setIsSubjectInvalid(!selectedSubject);
    setIsGradeInvalid(!selectedGrade);
    setIsTopicInvalid(!lessonTopic);
    if (!selectedGrade || !lessonTopic || isDisabled) {
      setShowDateError(isDisabled);
      return;
    }
    if (lessonCount !== selectedTimes.length) {
      setErrorMessage(t('lessonsAndTypesCountError'));
      return;
    }
    if (!checkIfLessonsWithinRange(lessonCount, selectedTimes)) {
      setErrorMessage(
        t('lessonNotInRange.lessonsHasToBe') +
          (lessonCount <= 8 ? 2 : 3) +
          t('lessonNotInRange.monthsRange')
      );
      return;
    }
    setLoading(true);
    setTimeAlreadyInCart(false);
    for (let index = 0; index < lessonCount; index++) {
      await onSelect({
        day: selectedTimes[index].date,
        time: selectedTimes[index].hour,
        lessonType: selectedTimes[index]?.lessonType,
        lessonStudentCount: selectedTimes[index]?.lessonStudentCount,
        lessonMax: selectedTimes[index]?.lessonMax,
      });
      await action(index);
    }

    if (!isNavigatingToCheckout) {
      setLoading(false);
      return;
    } else {
      await cartModalPresenter.openCheckout(user);
      setLoading(false);
    }
  };

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        height: '100%',
        maxWidth: '500px',
        margin: 'auto',
      }}
    >
      <BookALessonHeader
        vm={vm}
        selectedSubject={selectedSubject}
        selectedDiscount={selectedDiscount}
        priceWithDiscount={priceWithDiscount}
        selectedTimes={selectedTimes}
        lessonCount={lessonCount}
        showDateError={showDateError}
        isDisabled={isDisabled}
        setShowSelectedDates={setShowSelectedDates}
        discountOptions={discountOptions}
      />
      <BookALessonContent
        vm={vm}
        lessonCount={lessonCount}
        setLessonCount={setLessonCount}
        lessonFor={lessonFor}
        setLessonFor={setLessonFor}
        selectedSubject={selectedSubject}
        setSelectedSubject={setSelectedSubject}
        lessonGrades={lessonGrades}
        setLessonGrades={setLessonGrades}
        selectedGrade={selectedGrade}
        setSelectedGrade={setSelectedGrade}
        lessonTopic={lessonTopic}
        setLessonTopic={setLessonTopic}
        isSubjectInvalid={isSubjectInvalid}
        isGradeInvalid={isGradeInvalid}
        isTopicInvalid={isTopicInvalid}
        discountOptions={discountOptions}
        setIsSubjectInvalid={setIsSubjectInvalid}
      />

      <BookALessonFooter
        handleCartAction={handleCartAction}
        setIsLoadingCart={setIsLoadingCart}
        setIsLoadingPay={setIsLoadingPay}
        lessonTopic={lessonTopic}
        lessonType={lessonType}
        selectedSubject={selectedSubject}
        selectedGrade={selectedGrade}
        lessonFor={lessonFor}
        isLoadingCart={isLoadingCart}
        isLoadingPay={isLoadingPay}
        addToCart={addToCart}
        onNext={onNext}
        timeAlreadyInCart={timeAlreadyInCart}
        setTimeAlreadyInCart={setTimeAlreadyInCart}
        errorMessage={errorMessage}
      />
    </Flex>
  );
};

export default bookALesson;
